export enum BorrowerNotificationType {
  TextMessage = "TextMessage",
  Email = "Email",
  Phone = "Phone",
  Paper = "Paper",
}
